import Accordion from "../modules/accordion.js";

new Accordion('[data-accordion-header]');
